import Lottie from 'react-lottie';
import React from 'react';
import animationData from './lottie-loader.json';
import styles from './styles.module.scss';

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};

export const Loader = () => {
    return (
        <div className={styles.loaderWrapper}>
            <Lottie options={defaultOptions} height={124} />
            <div className={styles.gap} />
            <Lottie options={defaultOptions} height={124} />
            <div className={styles.gap} />
            <Lottie options={defaultOptions} height={124} />
            <div className={styles.gap} />
            <Lottie options={defaultOptions} height={124} />
            <div className={styles.gap} />
            <Lottie options={defaultOptions} height={124} />
            <div className={styles.gap} />
            <Lottie options={defaultOptions} height={124} />
        </div>
    );
};
